// dependencies
import React from "react";
import { View, StyleSheet } from "react-native";

// components
import Heading from "@cloudspire/legacy-resources/src/components/Heading";
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import RoomAddress from "@cloudspire/legacy-resources/src/components/RoomAddress";
import RoomRankings from "@cloudspire/legacy-resources/src/components/RoomRankings";
import RoomRateAndReviews from "@cloudspire/legacy-resources/src/components/RoomRateAndReviews";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";

const styles = StyleSheet.create({
  row: {
    width: "100%",
  },
  reviews: {
    alignItems: "flex-end",
  },
});

type PropsType = {
  room: ReturnType<
    typeof import("@cloudspire/legacy-resources/src/normalizers/room").roomParseData
  >;
};

const RoomAside: React.FunctionComponent<PropsType> = (props) => {
  const { room } = props;

  return (
    <>
      <Heading textStyle={{ fontSize: emToPx(1.25), fontWeight: "500" }}>
        {room.name}
      </Heading>

      <Stack marginTop={0.625} />

      <Heading textStyle={{ fontSize: emToPx(1) }}>{room.title}</Heading>

      <Stack marginTop={0.875} />

      <RoomAddress city={room.city} zipcode={room.zipcode} />

      <Stack marginTop={0.875} />

      <View style={styles.row}>
        <RoomRankings room={room} color={room.bestColor} />

        <Stack marginTop={0.5} />

        <View style={styles.reviews}>
          <RoomRateAndReviews rate={room.rate} reviews={room.reviews} />
        </View>
      </View>
    </>
  );
};

export default RoomAside;
